import {
  Row, Button, FormGroup, Label, Input, Alert, Modal, ModalHeader, ModalBody, ModalFooter,
  InputGroup, InputGroupAddon, InputGroupText,
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import React, { Fragment } from "react";
import "../estilos.css";
import Navbarh from "../navbar/Navbar";
import Pagination from "react-js-pagination";
import * as IoIcons from "react-icons/io";
import TimeField from "react-simple-timefield";
import BarcodeReader from "react-barcode-reader";
import useReciba from "../../hooks/useReciba";
import Moment from "moment";
import EtiquetaRAC from "./EtiquetaRAC";
import EtiquetaViajeraPT from "./EtiquetaViajeraPT";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { FaRegCopy, FaList, FaEllipsisV, FaShareAlt } from 'react-icons/fa'
import { RiSendPlaneFill, RiDeleteBin6Line } from 'react-icons/ri'
import EtiquetaNP from "./EtiquetaNP";

function Reciba() {
  const {
    numeroParte,
    pincoming,
    nFocus,
    pdescargarreciba,
    ppreciba,
    formType,
    color,
    aVisible,
    mensajeAlert,
    cargando,
    mRecibas,
    mRecibasNP,
    inputList,
    agregarLoteFaltante,
    clientes,
    formData,
    inputListPacking,
    packings,
    productos,
    isDisabled,
    modal1,
    modal2,
    locaciones,
    searchBy,
    estadoReciba,
    search,
    reciba,
    rfechaini,
    rfechafin,
    currentPage,
    recordPerPage,
    totalRecords,
    pageRange,
    modal,
    faltanDatos,
    addfile,
    recibaSerialesSinFiltro,
    serialesRepetidos,
    mEstatusUbicacion,
    onChangescheckALF,
    siguienteFoco,
    setMEstatusUbicacion,
    onDismiss,
    preciba,
    handleError,
    handleScan,
    onChangeCliente,
    onChanges,
    setInputListPacking,
    handleInputChangePacking,
    handleInputChangePO,
    agregarPacking,
    handleRemovePackingClick,
    setInputList,
    handleInputChangeProducto,
    onChangescheck,
    handleFocus,
    handleInputChangeSerial,
    handleInputChangeCantidad,
    handleChangeInputType,
    handleRemoveClick,
    guardarReciba,
    cancelarReciba,
    toggle1,
    toggle2,
    updateReciba,
    cancelarRecibaIncoming,
    aceptarEliminar,
    setInputUbicaciones,
    onChangesUbicacion,
    handleInputChangeLocacion,
    toggle,
    handleInputChangeEspacio,
    onChangesFechaUbicacion,
    guardarIncomming,
    nuevaReciba,
    buscarpor,
    onestadoReciba,
    setSearch,
    onSearchFecha,
    handlePageChange,
    onSearch,
    onChangesRFecha,
    fetchReciba,
    cliclMostrar,
    clicEditar,
    clicEliminar,
    clicDescargarDatos,
    clicDescargarDatosReciba,
    cliclIncoming,
  } = useReciba();

  return (
    <>
      <Navbarh />
      {ppreciba === true && (
        <>
          <Row>
            <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <IoIcons.IoMdClipboard
                className="iconoc floatleft"
                onClick={
                  formType.search("Incoming") > -1
                    ? cancelarRecibaIncoming
                    : preciba
                }
              />
              <h3>{formType}</h3>
            </div>
          </Row>
          <div className="conteiner3">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>

            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                  <img
                    width="150px"
                    alt="cargando"
                    src="assets/img/preloader.gif"
                  />
                </div>
              </Row>
            )}

            {formType === "Reciba" && (
              <Fragment>
                <Row>
                  {
                    //userName !== "GELA" && (
                    <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 text-left  ">
                      <button
                        class="cbutton btn-success margintop20px ml-3"
                        onClick={nuevaReciba}>
                        {" "}
                        <span class="fa fa-plus"> Agregar reciba</span>{" "}
                      </button>
                    </div>
                    /*)*/
                  }
                  <div class="col-lg-6 col-md-9 col-sm-12 col-xs-12 text-left  margintopmobil20px">
                    <InputGroup></InputGroup>
                    <Label>
                      <h5>Busqueda por: </h5>
                    </Label>
                    <select
                      name="recibabusqueda"
                      className="ml-2"
                      onChange={buscarpor}>
                      <option
                        value="cliente"
                        selected={searchBy === "cliente" ? true : false}>
                        Cliente
                      </option>
                      <option
                        value="paking"
                        selected={searchBy === "paking" ? true : false}>
                        Packing
                      </option>
                      <option
                        value="numero de parte"
                        selected={
                          searchBy === "numero de parte" ? true : false
                        }>
                        Número de parte
                      </option>
                      <option
                        value="lote"
                        selected={searchBy === "lote" ? true : false}>
                        Lote
                      </option>
                      <option
                        value="fecha"
                        selected={searchBy === "fecha" ? true : false}>
                        Fecha
                      </option>
                      <option
                        value="serial"
                        selected={searchBy === "serial" ? true : false}>
                        Serial
                      </option>
                      <option
                        value="serialBTI"
                        selected={searchBy === "serialBTI" ? true : false}>
                        Serial BTI
                      </option>
                      <option
                        value="id de reciba"
                        selected={searchBy === "id de reciba" ? true : false}>
                        ID de Reciba
                      </option>
                    </select>
                    <select
                      name="recibaestado"
                      className="estadoproductoscombo"
                      onChange={onestadoReciba}>
                      <option
                        value="todos"
                        selected={estadoReciba === "todos" ? true : false}>
                        Todo el material
                      </option>
                      <option
                        value="En reciba"
                        selected={estadoReciba === "En reciba" ? true : false}>
                        Material en Reciba
                      </option>
                      <option
                        value="Rechazado"
                        selected={estadoReciba === "Rechazado" ? true : false}>
                        Material rechazado
                      </option>
                      <option
                        value="Aceptado"
                        selected={estadoReciba === "Aceptado" ? true : false}>
                        Material aceptado
                      </option>
                      <option
                        value="Parcialmente Rechazado"
                        selected={
                          estadoReciba === "Parcialmente Rechazado"
                            ? true
                            : false
                        }>
                        Material Parcialmente Rechazado
                      </option>
                    </select>
                    {/*searchBy!=="fecha" &&()*/}
                    <Input
                      className="marginlbusqueda"
                      type={searchBy !== "fecha" ? "text" : "date"}
                      placeholder={"Búsqueda por " + searchBy}
                      onChange={
                        searchBy !== "fecha"
                          ? (e) => setSearch(e.target.value)
                          : onSearchFecha
                      }
                      onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                      value={search}
                    />
                  </div>
                  <div className=" form-group row col-lg-3 col-md-12 col-sm-12 col-xs-12">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>Del:</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="rfechaini"
                        type="date"
                        value={Moment(rfechaini).format("YYYY-MM-DD")}
                        onChange={onChangesRFecha}
                      />
                    </InputGroup>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>Al:</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="rfechafin"
                        type="date"
                        value={Moment(rfechafin).format("YYYY-MM-DD")}
                        onChange={onChangesRFecha}
                      />
                    </InputGroup>
                  </div>
                </Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left ">
                  <button
                    className="cbutton btn-dark floatright ml-2 "
                    title="Recargar página"
                    onClick={() => {
                      fetchReciba();
                    }}>
                    <IoIcons.IoMdRefresh /> Recargar{" "}
                  </button>
                  <button
                    class="btn-warning cbutton floatrightleft ml-2"
                    title="Exportar los datos a excel"
                    onClick={() => clicDescargarDatos("descarga")}>
                    <IoIcons.IoIosDownload /> Descargar datos
                  </button>
                  <button
                    class="btn-info cbutton floatrightleft ml-2"
                    title="Copiar detalle de reciba"
                    onClick={() => clicDescargarDatos("copiadetalle")}>
                    <IoIcons.IoIosCopy /> Copiar detalle
                  </button>
                  <button
                    class="btn-info cbutton floatrightleft"
                    title="Copiar datos generales de reciba"
                    onClick={() => clicDescargarDatos("copiageneral")}>
                    <IoIcons.IoIosCopy /> Copiar reciba
                  </button>
                </div>
                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                  <>
                    <ContextMenu id="contextmenu">
                      <MenuItem data={{ copy: 'MI50' }} >
                        <FaRegCopy className="copy" />
                        <span>Copy</span>
                      </MenuItem>
                      <MenuItem >
                        <FaEllipsisV className="openwith" />
                        <span>Open with</span>
                      </MenuItem>
                      <MenuItem >
                        <FaList className="watchlist" />
                        <span>Add to watchlist</span>
                      </MenuItem>
                      <MenuItem>
                        <RiSendPlaneFill className="send" />
                        <span>Send</span>
                      </MenuItem>
                      <MenuItem>
                        <RiDeleteBin6Line className="delete" />
                        <span>Delete</span>
                      </MenuItem>
                      <MenuItem>
                        <FaShareAlt className="share" />
                        <span>Share</span>
                      </MenuItem>
                    </ContextMenu>
                  </>
                  <ContextMenuTrigger id="contextmenu">
                    {/*Objetivo del menú.*/}
                  </ContextMenuTrigger>

                  <Table className=" mb-2  ">
                    <Thead class="thead-secondary">
                      <Tr>
                        <Th>ID</Th>
                        <Th>Cliente</Th>
                        <Th className="minwidth80px">Fecha y hora de reciba</Th>
                        <Th>Status</Th>
                        <Th>Cantidad Recibida</Th>
                        <Th>Packing </Th>
                        <Th>Número de parte</Th>
                        <Th>Lote</Th>
                        <Th>Serial</Th>
                        <Th>Serial BTI</Th>
                        <Th className="minwidth80px">
                          Acciones{" "}
                          {/*userName==="GELA"?"Incoming": "Acciones" */}{" "}
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {reciba.map((reciba, i) => (
                        <Tr class={i % 2 !== 0 ? "table-active" : ""}>
                          <Td>{reciba.numero}</Td>
                          <Td>{reciba.cliente}</Td>
                          <Td className="margintopmobil20px">
                            {Moment(reciba.fechaDeReciba).format("DD/MM/YYYY") +
                              " " +
                              reciba.horaDeReciba}
                          </Td>
                          <Td className="margintopmobil20px">
                            {reciba.status}
                          </Td>
                          <Td className="margintopmobil20px">
                            {reciba.cantidadRecibida}
                          </Td>
                          <Td className="margintopmobil20px">
                            {reciba.packings}
                          </Td>
                          <Td className="margintopmobil20px">
                            {reciba.numerosdeParte}
                          </Td>
                          <Td className="margintopmobil20px">{reciba.lotes}</Td>
                          <Td className="margintopmobil20px">
                            {reciba.seriales}
                          </Td>
                          <Td className="margintopmobil20px">
                            {reciba.serialesBTI}
                          </Td>
                          <Td className="margintopmobil40px">
                            {
                              //userName !== "GELA" && (
                              <>
                                <button
                                  class="btn-info cbutton mt-1 ml-1"
                                  onClick={() => cliclMostrar(reciba)}
                                  title="Detalles de reciba">
                                  {" "}
                                  <IoIcons.IoIosListBox />{" "}
                                </button>
                                <button
                                  class="btn-primary cbutton mt-1 ml-1"
                                  onClick={() =>
                                    clicEditar(
                                      reciba,
                                      reciba.clienteID,
                                      reciba.numero,
                                      reciba.cliente
                                    )
                                  }
                                  title="Editar">
                                  {" "}
                                  <IoIcons.IoIosCreate />{" "}
                                </button>
                                <button
                                  class="btn-danger cbutton mt-1 ml-1"
                                  onClick={() => clicEliminar(reciba)}
                                  title="Eliminar">
                                  {" "}
                                  <IoIcons.IoIosClose />{" "}
                                </button>
                                {/*pincoming === true && (
                                  <button
                                    class="btn-success cbutton mt-1 ml-1"
                                    onClick={() => cliclIncoming(reciba)}
                                    title="Incoming">
                                    {" "}
                                    <IoIcons.IoIosAlbums />{" "}
                                  </button>
                                )*/}
                                <button
                                  class="btn-info cbutton mt-1 ml-1"
                                  onClick={() => clicDescargarDatosReciba(reciba)}
                                  title="Copiar reciba">
                                  <IoIcons.IoIosCopy />
                                </button>
                              </>
                              /*)*/
                            }
                            {/*userName==="GELA" &&(
                                            <>
                                            <button class="btn-success cbutton mt-1 ml-1"  onClick={()=>cliclIncoming(reciba)}  title="Incoming"> <IoIcons.IoIosCreate/> </button>                                                                                                                         
                                            </>
                                        )*/}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </div>
                <div className="mt-3 mb-3">
                  Página {currentPage}, mostrando del{" "}
                  {recordPerPage * currentPage - recordPerPage + 1} al{" "}
                  {totalRecords < recordPerPage * currentPage
                    ? totalRecords
                    : recordPerPage * currentPage}{" "}
                  de {totalRecords} registros
                </div>
                <Row>
                  <div className="col-lg-12 col-md-12 col-sm-12  ">
                    <div className="floatcenter">
                      <Pagination
                        itemClass="page-item" // add it for bootstrap 4
                        linkClass="page-link" // add it for bootstrap 4
                        activePage={currentPage}
                        itemsCountPerPage={recordPerPage}
                        totalItemsCount={totalRecords}
                        pageRangeDisplayed={pageRange}
                        onChange={handlePageChange}
                      />
                    </div>
                  </div>
                </Row>
                {/*<div style={{ marginTop: 20 }}>{JSON.stringify(reciba)}</div>*/}
                <Modal isOpen={modal} toggle={toggle}>
                  <ModalHeader toggle={toggle}>Eliminar reciba</ModalHeader>
                  <ModalBody>
                    ¿Estás seguro que quieres eliminar la reciba{" "}
                    {formData.numero + " "}
                    del cliente {mRecibas.cliente} registrado el{" "}
                    {Moment(mRecibas.fechaDeReciba).format("DD/MM/YYYY") +
                      " a las " +
                      mRecibas.horaDeReciba}
                    ?
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" onClick={aceptarEliminar}>
                      Aceptar
                    </Button>{" "}
                    <Button color="secondary" onClick={toggle}>
                      Cancelar
                    </Button>
                  </ModalFooter>
                </Modal>
                {/*Modal para exportar datos 
                                <Modal isOpen={modal2} toggle={toggle2}>
                                    <ModalHeader toggle={toggle2}>Opciones de descarga </ModalHeader>
                                    <ModalBody>
                                        <Row>
                                            <div className="col-lg-12 col-md-12 col-sm-12  " >
                                                Tomar como base los datos de un archivo y agregar los datos de la reciba
                                                <Input
                                                    type="file"
                                                    placeholder="Upload file"
                                                    accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    onChange={(event) => {
                                                        addfile(event)
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12  margintop10px" >
                                                Descargar los datos en un nuevo archivo
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12  margintop10px" >
                                                <Label className="floatleft mr-3"><input type="checkbox" name="VUAP" className='ml-2' />Datos generales de la reciba </Label>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12  margintop10px" >
                                                <Label className="floatleft mr-3"><input type="checkbox" name="VUAP" className='ml-2' />Datos de detalle de la reciba</Label>

                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12  margintop10px" >
                                                <button class="btn-primary cbutton floatright" title="Exportar los datos a excel" onClick={() => clicDescargarDatos()}>  Aceptar</button>
                                            </div>
                                        </Row>


                                    </ModalBody>
                                    <ModalFooter>
                                        <button class="btn-secondary cbutton floatrigh" title="Cancelar" onClick={toggle2}>  Cancelar</button>
                                    </ModalFooter>
                                </Modal>*/}
              </Fragment>
            )}
          </div>
          <div className="conteiner2">
            {formType === "Detalle Reciba " + mRecibas.numero && (
              <Fragment>
                <Row>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatleft">
                      {/*<button class=" btn-secondary cbutton floatleft " color="primary" onClick={() => clicEditar(mRecibas, mRecibas.clienteID, mRecibas.numero)} title="Editar">
                                            <IoIcons.IoIosCreate />Editar </button>*/}
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatright">
                      <button
                        class="btn-info cbutton floatright"
                        onClick={preciba}
                        title="Regresar">
                        <IoIcons.IoMdArrowRoundBack />
                        Regresar{" "}
                      </button>
                    </div>
                  </div>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px scroll">
                    <div className="textaligmentleft">
                      {" "}
                      <h5>Datos generales</h5>
                    </div>
                    <Table className="margintop20px mb-2  ">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>ID</Th>
                          <Th>Cliente</Th>
                          <Th className="minwidth80px">
                            Fecha y hora de reciba
                          </Th>
                          <Th>Cantidad por reciba</Th>
                          <Th>Status</Th>
                          <Th> Quien Inspeccionó </Th>
                          <Th> Comentarios de inspección </Th>
                          <Th> PO'S </Th>
                          <Th> Registros </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        <Tr>
                          <Td>{mRecibas.numero}</Td>
                          <Td>{mRecibas.cliente}</Td>
                          <Td className="margintopmobil20px">
                            {Moment(mRecibas.fechaDeReciba).format(
                              "DD/MM/YYYY"
                            ) +
                              " " +
                              mRecibas.horaDeReciba}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.cantidadRecibida}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.status}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.quienInspecciono}
                          </Td>
                          <Td className="margintopmobil20px">
                            {mRecibas.comentarios}
                          </Td>
                          <Td className="margintopmobil50px">{mRecibas.po}</Td>
                          <Td className="margintopmobil50px">
                            {inputList.length ? inputList.length : 0}
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 textaligmentleft margintop20px">
                    <h5>Detalle</h5>
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px">

                    <EtiquetaRAC
                      indice={0}
                      inputList={inputList}
                      mRecibas={mRecibas}
                      tipo={"todo"}
                      bColor={"warning floatrightleft"}
                      btitle={"Etiqueta viajera"}
                      llamada={"Todo"}
                    />

                    {mRecibasNP.length > 0 && (
                      <EtiquetaNP
                        indice={0}
                        inputList={mRecibasNP}
                        mRecibas={mRecibas}
                        tipo={"todo"}
                        bColor={"dark floatrightleft mr-3"}
                        btitle={"Etiqueta por número de parte"}
                        llamada={"Todo"}
                      />
                    )}

                  </div>
                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll ">
                    <Table className=" mb-2">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>
                            {" "}
                            {mRecibas.cliente === "Olson Internacional"
                              ? "Line"
                              : "Packing"}
                          </Th>
                          <Th>Número de parte</Th>
                          <Th>Descripción</Th>
                          <Th>Material en</Th>
                          <Th>Empaques</Th>
                          <Th>Peso Klg</Th>
                          <Th>Proceso</Th>
                          <Th>Lote</Th>
                          <Th>Serial</Th>
                          <Th className="minwidth80px">Serial BTI</Th>
                          <Th>Cantidad por serial</Th>
                          <Th>Estatus</Th>
                          <Th>Ubicación</Th>
                          <Th>Locación</Th>
                          <Th>Espacios</Th>
                          <Th>Fecha y hora de ubicación </Th>
                          <Th>Quién Inspeccionó</Th>
                          <Th>Defecto</Th>
                          <Th>Comentarios</Th>
                          {<Th>Imprimir Etiqueta</Th>}
                        </Tr>
                      </Thead>
                      <Tbody>
                        {inputList.map((x, i) => {
                          return (
                            x.activo && (
                              <Tr
                                class={
                                  !x.scolor
                                    ? i % 2 !== 0
                                      ? "table-active"
                                      : ""
                                    : x.scolor
                                }>
                                <Td className="margintopmobil20px">
                                  {x.packing}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.numerodeParte}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.descripcion}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.materialEn}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.materialEnCantidad}
                                </Td>
                                <Td className="margintopmobil20px">{x.peso}</Td>
                                <Td className="margintopmobil20px">
                                  <Label>{(x.Ecoat === true || (!x.Ecoat && x.precioUnitario)) ? "Ecoat" : ""}</Label>
                                  <Label className="mt-1">{x.Pcoat === true ? "Powder coat" : ""}</Label>
                                  {/*<Label className="mt-1">{x.Platinado === true ? "Platinado" : ""}</Label>*/}
                                </Td>
                                <Td className="margintopmobil20px">{x.lote}</Td>
                                <Td className="margintopmobil20px">
                                  {x.serial}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.serialRecibaBTI}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.cantidadRecibida}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.status}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {x.ubicacion}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.locacion}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.espacioOcupado}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.fechaDeUbicacion +
                                    " " +
                                    x.horaDeUbicacion}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.quienInspecciono}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.defectoCuarentena}{" "}
                                </Td>
                                <Td className="margintopmobil20px">
                                  {" "}
                                  {x.comentariosdeinspeccion}{" "}
                                </Td>
                                {<Td>
                                  <EtiquetaViajeraPT
                                    indice={i}
                                    reciba={x}
                                    mRecibas={mRecibas}
                                    tipo={"total"}
                                    bColor={"warning mt-1 ml-1"}
                                    btitle={"Etiqueta viajera - Reciba"}
                                    llamada={"Todo"}
                                  />
                                  <EtiquetaViajeraPT
                                    indice={i}
                                    reciba={x}
                                    mRecibas={mRecibas}
                                    tipo={"parcial"}
                                    bColor={"dark mt-1 ml-1"}
                                    btitle={
                                      "Etiqueta viajera - Almacén/Cuarentena"
                                    }
                                    llamada={"Todo"}
                                  />
                                </Td>}
                              </Tr>
                            )
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>
                  {/*<div  className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 " style={{ marginTop: 20 }}>{JSON.stringify(input)}</div>*/}
                </Row>
              </Fragment>
            )}
            {formType === "Nueva Reciba" && (
              <Fragment>
                <BarcodeReader
                  onError={handleError}
                  onScan={handleScan}
                  minLength={1}
                />
                <Row>
                  {/*"Año:" + Moment(new Date()).format("YYYY") + " , Mes:" + Moment(new Date()).format("MM")*/}
                  <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                    <Label
                      className={
                        faltanDatos === true && formData.clienteID === ""
                          ? "floatleft fcolorred"
                          : "floatleft"
                      }>
                      Cliente*:{" "}
                    </Label>
                    <select
                      name="clienteID"
                      className="floatleft custom-select"
                      onChange={onChangeCliente}>
                      <option className="" value="">
                        Elige un cliente
                      </option>
                      {clientes.map((cliente) => (
                        <option className="" value={cliente.id}>
                          {cliente.cliente}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label
                        className={
                          faltanDatos === true && formData.fechaDeReciba === ""
                            ? "floatleft fcolorred"
                            : "floatleft"
                        }>
                        Fecha de Reciba*: {/*nFocus*/}
                      </Label>
                      <Input
                        name="fechaDeReciba"
                        type="date"
                        value={formData.fechaDeReciba}
                        onChange={onChanges}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label
                        className={
                          faltanDatos === true && formData.horaDeReciba === ""
                            ? "floatleft fcolorred"
                            : "floatleft"
                        }>
                        Hora de Reciba*:
                      </Label>
                      <TimeField
                        name="horaDeReciba"
                        className="w-100 custom-time"
                        value={formData.horaDeReciba}
                        onChange={onChanges}
                      />
                    </FormGroup>
                  </div>
                </Row>
                <Row className="">
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft ">Quien Inspeccionó:</Label>
                      <select
                        name="quienInspecciono"
                        className=" custom-select"
                        onChange={onChanges}>
                        <option className="" value="">
                          Elige una opción
                        </option>
                        <option value="Rubi Landin">Rubi Landin</option>
                        <option value="Nallely Frausto">Nallely Frausto</option>
                        <option value="Alma Espinoza">Alma Espinoza</option>
                        <option value="Isaac Martinez">Isaac Martinez</option>
                        {/*                    
                        <option value="Luis Sánchez">Luis Sánchez</option>*/}
                      </select>
                    </FormGroup>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft ">Comentarios:</Label>
                      <Input
                        name="comentarios"
                        maxLength={600}
                        type="textarea"
                        rows="1"
                        onChange={onChanges}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                    <Label className="floatleft ml-2">
                      <input type="checkbox"
                        name="CNALiberado"
                        onChange={onChangescheckALF}
                        className='ml-2'
                        checked={agregarLoteFaltante} />
                      Poner ND al Lote faltante
                    </Label>
                  </div>
                </Row>

                {inputListPacking.map((packing, ipacking) => {
                  return (
                    <>
                      <Row>
                        <div className="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                          <FormGroup>
                            <Label
                              className={
                                faltanDatos === true && packing.packing === ""
                                  ? "floatleft fcolorred"
                                  : "floatleft"
                              }>
                              {formData.cliente === "Olson Internacional"
                                ? "Line*:"
                                : "Packing*:"}
                            </Label>
                            <Input
                              name="packing"
                              maxLength={20}
                              type="text"
                              value={packing.packing}
                              onChange={(e) =>
                                setInputListPacking(
                                  handleInputChangePacking(e, ipacking, [
                                    ...inputListPacking,
                                  ])
                                )
                              }
                            />
                          </FormGroup>
                        </div>
                        <div className="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                          <FormGroup>
                            <Label
                              className={
                                faltanDatos === true && packing.po === ""
                                  ? "floatleft fcolorred"
                                  : "floatleft"
                              }>
                              PO*:
                            </Label>
                            <Input
                              name="po"
                              maxLength={20}
                              type="text"
                              value={packing.po}
                              onChange={(e) =>
                                setInputListPacking(
                                  handleInputChangePO(e, ipacking, [
                                    ...inputListPacking,
                                  ])
                                )
                              }
                            />
                          </FormGroup>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                          {inputListPacking.length - 1 === ipacking && (
                            <>
                              <div className="floatrightleft">
                                <button
                                  class="btn-success cbutton ml-2  mt-4 "
                                  title="Agregar packing/line"
                                  onClick={() =>
                                    setInputListPacking(
                                      agregarPacking(ipacking, [
                                        ...inputListPacking,
                                        {
                                          packing: "",
                                          packingindex: packings,
                                          po: packing.po,
                                        },
                                      ])
                                    )
                                  }>
                                  {" "}
                                  {formData.cliente === "Olson Internacional"
                                    ? "Agregar line"
                                    : "Agregar packing"}{" "}
                                </button>
                              </div>
                            </>
                          )}
                          {ipacking > 0 && (
                            <>
                              <div className="floatright">
                                <button
                                  class="btn-danger cbutton ml-2 mt-4 "
                                  title="Eliminar Packing/line"
                                  onClick={() =>
                                    setInputListPacking(
                                      handleRemovePackingClick(ipacking, [
                                        ...inputListPacking,
                                      ])
                                    )
                                  }>
                                  {" "}
                                  {formData.cliente === "Olson Internacional"
                                    ? "Eliminar line"
                                    : "Eliminar packing"}{" "}
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                        {/*<div style={{ marginTop: 20 }}>{JSON.stringify(inputListPacking)}</div>*/}
                      </Row>
                      <Row>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-5  scroll">
                          <Table className=" ">
                            <Thead class="thead-secondary">
                              <Tr>
                                <Th>#</Th>
                                <Th className=" minwidth200px">
                                  Número de parte*
                                </Th>
                                <Th className=" minwidth400px">Descripción</Th>
                                <Th className=" minwidth400px">Serial*</Th>
                                <Th className=" minwidth400px">Cantidad*</Th>
                                <Th className=" minwidth200px">Lote*</Th>
                                <Th className=" minwidth130px">
                                  Material en *
                                </Th>
                                <Th className=" ">Empaque*</Th>
                                <Th className="minwidth80px">Peso Klg</Th>
                                <Th className="minwidth80px">Proceso*</Th>
                                <Th className=" minwidth80px"> Acciones </Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {inputList.map((x, i) => {
                                return (
                                  x.activo === true &&
                                  x.packingindex === packing.packingindex && (
                                    <Tr class={x.sombreado ? "table-active" : ""}>
                                      <Td>{x.orden}</Td>
                                      <Td className={(((x.numerodeParte !== "" && x.parteValido === false) ||
                                        (x.numerodeParte === "" && faltanDatos === true) && i < (inputList.length - 1))) ?
                                        "margintopmobil20px novalido select-editable" :
                                        "margintopmobil20px select-editable"
                                      }>

                                        <select name="productoID"
                                          className="floatleft custom-select"
                                          id={"n" + x.fid}
                                          onFocus={(e) => handleFocus(e, i)}
                                          onChange={(e) => setInputList(handleInputChangeProducto(e, i, [...inputList]))}>
                                          {<option className="" value="" selected={x.productoID === "" ? true : false}>
                                            Elije un número
                                          </option>}
                                          {productos.map((producto) => (
                                            <option value={producto.id} selected={x.productoID === producto.id ? true : false}>
                                              {producto.numerodeParte}
                                            </option>
                                          ))}
                                        </select>
                                        <input id={"n" + x.fid}
                                          onFocus={(e) => handleFocus(e, i)}
                                          name="numerodeParte"
                                          maxLength={20}
                                          type="text"
                                          placeholder={x.parteValido === false ? "No válido" : ""}
                                          value={x.numerodeParte}
                                          onChange={(e) => setInputList(handleInputChangeProducto(e, i, [...inputList]))}
                                        />
                                      </Td>
                                      <Td>
                                        <Input
                                          name="descripcion"
                                          maxLength={20}
                                          value={x.descripcion}
                                          placeholder="Descripción"
                                          disabled
                                        />
                                      </Td>
                                      <Td className={(((x.serial !== "" && x.serialDuplicado === true) ||
                                        (x.serial === "" && faltanDatos === true)) && i < (inputList.length - 1)) ? "novalido" : " "}>
                                        <Input
                                          name="serial"
                                          maxLength={20}
                                          onFocus={(e) => handleFocus(e, i)}
                                          type="text"
                                          value={x.serial}
                                          id={"s" + x.fid}
                                          onChange={(e) => setInputList(handleInputChangeSerial(e, i, [...inputList,]))}
                                        />
                                      </Td>
                                      <Td className={x.cantidadRecibida === "" && faltanDatos === true && i < (inputList.length - 1) ? "novalido" : " "}>
                                        <Input
                                          name="cantidadRecibida"
                                          maxLength={10}
                                          onFocus={(e) => handleFocus(e, i)}
                                          value={x.cantidadRecibida}
                                          type="text"
                                          id={"c" + x.fid}
                                          onChange={(e) => setInputList(handleInputChangeCantidad(e, i, [...inputList,]))}
                                        />
                                      </Td>
                                      <Td className={x.lote === "" && faltanDatos === true && i < (inputList.length - 1) ?
                                        "margintopmobil20px novalido" : " margintopmobil20px"}>
                                        <Input
                                          value={x.lote}
                                          onFocus={(e) => handleFocus(e, i)}
                                          className="textaligmentcenter"
                                          name="lote"
                                          maxLength={25}
                                          type="text"
                                          id={"l" + x.fid}
                                          onChange={(e) => setInputList(handleInputChangeSerial(e, i, [...inputList,]))}
                                        />
                                      </Td>
                                      <Td className={x.materialEn === "" && faltanDatos === true && i < (inputList.length - 1) ? "novalido" : " "}>
                                        <select name="materialEn" className=" custom-select"
                                          onChange={(e) => setInputList(handleInputChangeSerial(e, i, [...inputList,]))}>
                                          <option value="Contenedor" selected={x.materialEn === "Contenedor" ? true : false}>
                                            Contenedor
                                          </option>
                                          <option value="Caja" selected={x.materialEn === "Caja" ? true : false}>
                                            Caja
                                          </option>
                                        </select>
                                      </Td>
                                      <Td className={x.materialEnCantidad === "" && faltanDatos === true && i < (inputList.length - 1) ? "novalido" : " "}>
                                        <Input
                                          value={x.materialEnCantidad}
                                          className="textaligmentcenter"
                                          name="materialEnCantidad"
                                          maxLength={4}
                                          type="text"
                                          onChange={(e) => setInputList(handleInputChangeCantidad(e, i, [...inputList,]))}
                                        />
                                      </Td>
                                      <Td className="margintopmobil20px">
                                        <Input
                                          value={x.peso}
                                          className="textaligmentcenter"
                                          name="peso"
                                          maxLength={30}
                                          type="text"
                                          id={"l" + x.fid}
                                          onChange={(e) => setInputList(handleInputChangeSerial(e, i, [...inputList,]))}
                                        />
                                      </Td>
                                      <Td className="margintopmobil20px">
                                        <FormGroup >
                                          {(x.Ecoat === true || x.Ecoat === false) && (
                                            <Label className="floatleft ">
                                              {/* <input type="checkbox" name="Ecoat" onChange={(e) => setInputList(onChangescheck(e, i, [...inputList,]))} checked={x.Ecoat} disabled={(!x.Pcoat && !x.Platinado && x.Ecoat === true) ? true : false} />*/}
                                              Ecoat
                                            </Label>
                                          )}
                                          {(x.Pcoat === true || x.Pcoat === false) && (
                                            <Label className="floatleft ">
                                              {/*<input type="checkbox" name="Pcoat" onChange={(e) => setInputList(onChangescheck(e, i, [...inputList,]))} checked={x.Pcoat} disabled={(!x.Ecoat && !x.Platinado && x.Pcoat === true) ? true : false} />*/}
                                              Powder coat
                                            </Label>
                                          )}
                                          {(x.Platinado === true || x.Platinado === false) && (
                                            <Label className="floatleft">
                                              {/*<input type="checkbox" name="Platinado" onChange={(e) => setInputList(onChangescheck(e, i, [...inputList,]))} checked={x.Platinado} disabled={(!x.Pcoat && !x.Ecoat && x.Platinado === true) ? true : false} />*/}
                                              Platinado
                                            </Label>
                                          )}
                                        </FormGroup>
                                      </Td>
                                      <Td className="marginbottommobil40px">
                                        {/*<button
                                          class="btn-warning cbutton floatleft "
                                          value="inputList"
                                          title={x.manual === true ? "Ingresar datos manualmente" : "Ingresar por código de barras"}
                                          onClick={() => setInputList(handleChangeInputType(i, [...inputList,]))}>
                                          {x.manual === true ? (<IoIcons.IoMdHand />) : (<IoIcons.IoMdBarcode />)}
                                        </button>*/}
                                        {(x.ultimoxpacking === false && inputList.length > 2) && (
                                          <button
                                            class="btn-danger cbutton "
                                            title="Eliminar serial y cantidad recibida"
                                            onClick={() => setInputList(handleRemoveClick(i, [...inputList,]))}>
                                            <IoIcons.IoMdClose />
                                          </button>
                                        )}
                                      </Td>
                                    </Tr>
                                  )
                                );
                              })}
                            </Tbody>
                          </Table>
                          {/*<div style={{ marginTop: 20 }}>{JSON.stringify(serialesRepetidos)}</div>*/}
                          {/*<div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div>*/}
                        </div>
                      </Row>
                    </>
                  );
                })}
                <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12">
                  <div className="floatrightleft">
                    <Button
                      onClick={guardarReciba}
                      disabled={isDisabled}
                      color="primary">
                      Guardar
                    </Button>
                    <Button onClick={cancelarReciba} color="danger">
                      Cancelar
                    </Button>
                  </div>
                </div>
                {/*<div className="scroll" style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div>*/}
                {/*<div style={{ marginTop: 20 }}>{JSON.stringify(formData)}</div>*/}
              </Fragment>
            )}
            {formType === "Editar Reciba " + formData.numero && (
              <Fragment>
                <BarcodeReader
                  onError={handleError}
                  onScan={handleScan}
                  minLength={1}
                />
                <Row>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                    <Label className="floatleft">Cliente*: </Label>
                    <select
                      name="clienteID"
                      className="floatleft custom-select"
                      onChange={onChangeCliente}>
                      <option className="" value="">
                        Elige un cliente
                      </option>
                      {clientes.map((cliente) => (
                        <option
                          className=""
                          value={cliente.id}
                          selected={
                            formData.clienteID === cliente.id ? true : false
                          }>
                          {cliente.cliente}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft ">Fecha de Reciba*:</Label>
                      <Input
                        name="fechaDeReciba"
                        value={formData.fechaDeReciba}
                        type="date"
                        onChange={onChanges}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft ">Hora de Reciba*:</Label>
                      <TimeField
                        name="horaDeReciba"
                        value={formData.horaDeReciba}
                        className="w-100 custom-time"
                        onChange={onChanges}
                      />
                    </FormGroup>
                  </div>
                </Row>
                <Row className="">
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft ">Quien Inspeccionó:</Label>
                      <select
                        name="quienInspecciono"
                        className=" custom-select"
                        onChange={onChanges}>
                        <option className="" value="">
                          Elige una opción
                        </option>
                        <option value="Rubi Landin" selected={formData.quienInspecciono === "Rubi Landin" ? true : false}>Rubi Landin</option>
                        <option value="Nallely Frausto" selected={formData.quienInspecciono === "Nallely Frausto" ? true : false}>Nallely Frausto</option>
                        <option value="Alma Espinoza " selected={formData.quienInspecciono === "Alma Espinoza " ? true : false}>Alma Espinoza </option>
                        <option value="Isaac Martinez" selected={formData.quienInspecciono === "Isaac Martinez" ? true : false}>Isaac Martinez</option>
                        {/*formData.quienInspecciono === "Nallely Frausto" && (<option value="Nallely Frausto" selected={formData.quienInspecciono === "Nallely Frausto" ? true : false}>Nallely Frausto</option>)*/}
                        {formData.quienInspecciono === "Ximena Mejía" && (<option value="Ximena Mejía" selected={formData.quienInspecciono === "Ximena Mejía" ? true : false}> Ximena Mejía</option>)}
                        {formData.quienInspecciono === "Nathanael Espinoza" && (<option value="Nathanael Espinoza" selected={formData.quienInspecciono === "Nathanael Espinoza" ? true : false}> Nathanael Espinoza</option>)}
                        {formData.quienInspecciono === "Luis Sánchez" && (<option value="Luis Sánchez" selected={formData.quienInspecciono === "Luis Sánchez" ? true : false}> Luis Sánchez</option>)}
                        {formData.quienInspecciono === "Nereyda Vargas" && (<option value="Nereyda Vargas" selected={formData.quienInspecciono === "Nereyda Vargas" ? true : false}> Nereyda Vargas</option>)}
                        {formData.quienInspecciono === "Victor Ponce" && (<option value="Victor Ponce" selected={formData.quienInspecciono === "Victor Ponce" ? true : false}> Victor Ponce</option>)}

                      </select>
                      {/*<Input  name="quienInspecciono" value={formData.quienInspecciono} type="text" onChange={onChanges}/>*/}
                    </FormGroup>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                    <FormGroup>
                      <Label className="floatleft ">Comentarios:</Label>
                      <Input
                        name="comentarios"
                        maxLength={600}
                        value={formData.comentarios}
                        type="textarea"
                        rows="1"
                        onChange={onChanges}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                    <Label className="floatleft ml-2">
                      <input type="checkbox"
                        name="CNALiberado"
                        onChange={onChangescheckALF}
                        className='ml-2'
                        checked={agregarLoteFaltante} />
                      Poner ND al Lote faltante
                    </Label>
                  </div>
                  {/*<div style={{ marginTop: 20 }}>{JSON.stringify(formData)}</div>*/}
                </Row>
                {inputListPacking.map((packing, ipacking) => {
                  return (
                    <>
                      <Row>
                        <div className="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                          <FormGroup>
                            <Label className="floatleft ">
                              {formData.cliente === "Olson Internacional"
                                ? "Line*:"
                                : "Packing*:"}
                            </Label>
                            <Input
                              name="packing"
                              maxLength={20}
                              type="text"
                              value={packing.packing}
                              onChange={(e) =>
                                setInputListPacking(
                                  handleInputChangePacking(e, ipacking, [
                                    ...inputListPacking,
                                  ])
                                )
                              }
                            />
                          </FormGroup>
                        </div>
                        <div className="col-lg-4 col-md-3 col-sm-12 col-xs-12">
                          <FormGroup>
                            <Label className="floatleft ">PO*:</Label>
                            <Input
                              name="po"
                              maxLength={20}
                              type="text"
                              value={packing.po}
                              onChange={(e) =>
                                setInputListPacking(
                                  handleInputChangePO(e, ipacking, [
                                    ...inputListPacking,
                                  ])
                                )
                              }
                            />
                          </FormGroup>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                          {inputListPacking.length - 1 === ipacking && (
                            <>
                              <div className="floatrightleft">
                                <button
                                  class="btn-success cbutton ml-2  mt-4 "
                                  title="Agregar packing/line"
                                  onClick={() =>
                                    setInputListPacking(
                                      agregarPacking(ipacking, [
                                        ...inputListPacking,
                                        {
                                          packing: "",
                                          packingindex: packings,
                                          po: packing.po,
                                        },
                                      ])
                                    )
                                  }>
                                  {" "}
                                  {formData.cliente === "Olson Internacional"
                                    ? "Agregar line"
                                    : "Agregar packing"}{" "}
                                </button>
                              </div>
                            </>
                          )}
                          {ipacking > 0 && (
                            <>
                              <div className="floatright">
                                <button
                                  class="btn-danger cbutton ml-2 mt-4 "
                                  title="Eliminar Packing/line"
                                  onClick={() =>
                                    setInputListPacking(
                                      handleRemovePackingClick(ipacking, [
                                        ...inputListPacking,
                                      ])
                                    )
                                  }>
                                  {" "}
                                  {formData.cliente === "Olson Internacional"
                                    ? "Eliminar line"
                                    : "Eliminar packing"}{" "}
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                        {/*<div style={{ marginTop: 20 }}>{JSON.stringify(inputListPacking)}</div>*/}
                      </Row>
                      <Row>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-5  scroll">
                          <Table className=" ">
                            <Thead class="thead-secondary">
                              <Tr>
                                <Th>#</Th>
                                <Th className=" minwidth200px">
                                  Número de parte*
                                </Th>
                                <Th className=" minwidth200px">Descripción</Th>
                                <Th className=" minwidth200px">Serial*</Th>
                                <Th>Cantidad*</Th>
                                <Th className=" minwidth200px">Lote*</Th>
                                <Th className=" minwidth130px">Material En*</Th>
                                <Th className=" minwidth80px">Empaques*</Th>
                                <Th className="minwidth80px">Peso Klg</Th>
                                <Th className="minwidth80px">Proceso*</Th>
                                <Th className=" minwidth80px"> Acciones </Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {inputList.map((x, i) => {
                                return (
                                  x.activo === true &&
                                  x.packingindex === packing.packingindex && (
                                    <Tr
                                      class={x.sombreado ? "table-active" : ""}>
                                      <Td>{x.orden}</Td>
                                      <Td className={(((x.numerodeParte !== "" && x.parteValido === false) ||
                                        (x.numerodeParte === "" && faltanDatos === true) && i < (inputList.length - 1))) ?
                                        "margintopmobil20px novalido select-editable" :
                                        "margintopmobil20px select-editable"
                                      }>

                                        <select name="productoID"
                                          className="floatleft custom-select"
                                          id={"n" + x.fid}
                                          onFocus={(e) => handleFocus(e, i)}
                                          onChange={(e) => setInputList(handleInputChangeProducto(e, i, [...inputList]))}>
                                          {<option className="" value="" selected={x.productoID === "" ? true : false}>
                                            Elije un número
                                          </option>}
                                          {productos.map((producto) => (
                                            <option value={producto.id} selected={x.productoID === producto.id ? true : false}>
                                              {producto.numerodeParte}
                                            </option>
                                          ))}
                                        </select>
                                        <input id={"n" + x.fid}
                                          onFocus={(e) => handleFocus(e, i)}
                                          name="numerodeParte"
                                          maxLength={20}
                                          type="text"
                                          placeholder={x.parteValido === false ? "No válido" : ""}
                                          value={x.numerodeParte}
                                          onChange={(e) => setInputList(handleInputChangeProducto(e, i, [...inputList]))}
                                        />
                                      </Td>
                                      <Td>
                                        <Input
                                          name="descripcion"
                                          maxLength={20}
                                          value={x.descripcion}
                                          placeholder="Descripción"
                                          disabled
                                        />{" "}
                                      </Td>
                                      <Td
                                        className={
                                          x.serial !== "" &&
                                            x.serialDuplicado === true
                                            ? "novalido"
                                            : " "
                                        }>
                                        <Input
                                          name="serial"
                                          maxLength={20}
                                          type="text"
                                          value={x.serial}
                                          onFocus={(e) => handleFocus(e, i)}
                                          onChange={(e) =>
                                            setInputList(
                                              handleInputChangeSerial(e, i, [
                                                ...inputList,
                                              ])
                                            )
                                          }
                                        />
                                      </Td>
                                      <Td>
                                        <Input
                                          name="cantidadRecibida"
                                          maxLength={10}
                                          onFocus={(e) => handleFocus(e, i)}
                                          value={x.cantidadRecibida}
                                          type="text"
                                          onChange={(e) =>
                                            setInputList(
                                              handleInputChangeCantidad(e, i, [
                                                ...inputList,
                                              ])
                                            )
                                          }
                                        />
                                      </Td>
                                      <Td className="margintopmobil20px">
                                        <Input
                                          value={x.lote}
                                          onFocus={(e) => handleFocus(e, i)}
                                          className="textaligmentcenter"
                                          name="lote"
                                          maxLength={25}
                                          type="text"
                                          onChange={(e) =>
                                            setInputList(
                                              handleInputChangeSerial(e, i, [
                                                ...inputList,
                                              ])
                                            )
                                          }
                                        />
                                      </Td>
                                      {
                                        <Td>
                                          <select
                                            name="materialEn"
                                            className=" custom-select"
                                            onChange={(e) =>
                                              setInputList(
                                                handleInputChangeSerial(e, i, [
                                                  ...inputList,
                                                ])
                                              )
                                            }>
                                            <option
                                              value="Contenedor"
                                              selected={
                                                x.materialEn === "Contenedor"
                                                  ? true
                                                  : false
                                              }>
                                              Contenedor
                                            </option>
                                            <option
                                              value="Caja"
                                              selected={
                                                x.materialEn === "Caja"
                                                  ? true
                                                  : false
                                              }>
                                              Caja
                                            </option>
                                          </select>
                                        </Td>
                                      }
                                      <Td>
                                        <Input
                                          value={x.materialEnCantidad}
                                          className="textaligmentcenter"
                                          name="materialEnCantidad"
                                          maxLength={4}
                                          type="text"
                                          onChange={(e) =>
                                            setInputList(
                                              handleInputChangeCantidad(e, i, [
                                                ...inputList,
                                              ])
                                            )
                                          }
                                        />
                                      </Td>
                                      <Td className="margintopmobil20px">
                                        <Input
                                          value={x.peso}
                                          className="textaligmentcenter"
                                          name="peso"
                                          maxLength={30}
                                          type="text"
                                          id={"l" + x.fid}
                                          onChange={(e) =>
                                            setInputList(
                                              handleInputChangeSerial(e, i, [
                                                ...inputList,
                                              ])
                                            )
                                          }
                                        />
                                      </Td>
                                      <Td className="margintopmobil20px">
                                        <FormGroup >
                                          {(x.Ecoat === true || x.Ecoat === false) && (
                                            <Label className="floatleft ">
                                              {/*<input type="checkbox" name="Ecoat" onChange={(e) => setInputList(onChangescheck(e, i, [...inputList,]))} checked={x.Ecoat} disabled={(!x.Pcoat && !x.Platinado && x.Ecoat === true) ? true : false} />*/}
                                              Ecoat
                                            </Label>
                                          )}
                                          {(x.Pcoat === true || x.Pcoat === false) && (
                                            <Label className="floatleft ">
                                              {/*<input type="checkbox" name="Pcoat" onChange={(e) => setInputList(onChangescheck(e, i, [...inputList,]))} checked={x.Pcoat} disabled={(!x.Ecoat && !x.Platinado && x.Pcoat === true) ? true : false} />*/}
                                              Powder coat
                                            </Label>
                                          )}
                                          {(x.Platinado === true || x.Platinado === false) && (
                                            <Label className="floatleft">
                                              {/*<input type="checkbox" name="Platinado" onChange={(e) => setInputList(onChangescheck(e, i, [...inputList,]))} checked={x.Platinado} disabled={(!x.Pcoat && !x.Ecoat && x.Platinado === true) ? true : false} />*/}
                                              Platinado
                                            </Label>
                                          )}
                                        </FormGroup>
                                      </Td>
                                      <Td className="margintopmobil20px marginbottommobil40px">
                                        {/*<button
                                          class="btn-warning cbutton floatleft "
                                          value="inputList"
                                          title={
                                            x.manual === true
                                              ? "Ingresar datos manualmente"
                                              : "Ingresar por código de barras"
                                          }
                                          onClick={() =>
                                            setInputList(
                                              handleChangeInputType(i, [
                                                ...inputList,
                                              ])
                                            )
                                          }>
                                          {" "}
                                          {x.manual === true ? (
                                            <IoIcons.IoMdHand />
                                          ) : (
                                            <IoIcons.IoMdBarcode />
                                          )}{" "}
                                        </button>*/}
                                        {(x.ultimoxpacking === false && inputList.length > 1) && (
                                          <button
                                            class="btn-danger cbutton "
                                            title="Eliminar serial y cantidad recibida"
                                            onClick={() =>
                                              setInputList(
                                                handleRemoveClick(i, [
                                                  ...inputList,
                                                ])
                                              )
                                            }>
                                            <IoIcons.IoMdClose />
                                          </button>
                                        )}
                                      </Td>
                                    </Tr>
                                  )
                                );
                              })}
                            </Tbody>
                          </Table>
                          {/*<div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div>*/}
                        </div>
                      </Row>
                    </>
                  );
                })}
                <div>
                  <Button
                    className="floatright"
                    onClick={preciba}
                    color="danger">
                    Cancelar
                  </Button>
                  <Button
                    className="floatright"
                    onClick={updateReciba}
                    disabled={isDisabled}
                    color="primary">
                    Guardar
                  </Button>
                </div>
              </Fragment>
            )}
            <Modal isOpen={modal1} toggle={toggle1}>
              <ModalHeader toggle={toggle1}>Asignar locación</ModalHeader>
              <ModalBody>
                ¿Deseas establecer la misma locación para el material recibido
                en cajas que tenga el mismo número de lote?
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={"aceptarEliminar"}>
                  Aceptar
                </Button>{" "}
                <Button color="secondary" onClick={toggle1}>
                  Cancelar
                </Button>
              </ModalFooter>
            </Modal>
          </div>
          <div className="conteiner3">
            {formType === "Incoming Reciba " + formData.numero && (
              <Fragment>
                <div className="">
                  <Row>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <button
                        class="btn-info cbutton floatright"
                        onClick={cancelarRecibaIncoming}
                        title="Regresar">
                        {" "}
                        <IoIcons.IoMdArrowRoundBack />
                        Regresar{" "}
                      </button>
                    </div>
                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px scroll">
                      <div className="textaligmentleft">
                        {" "}
                        <h5>Datos generales</h5>
                      </div>
                      <Table className="margintop20px mb-2  ">
                        <Thead class="thead-secondary">
                          <Tr>
                            <Th>ID</Th>
                            <Th>Cliente</Th>
                            <Th className="minwidth80px">
                              Fecha y hora de reciba
                            </Th>
                            <Th>Cantidad Recibida</Th>
                            <Th>Status</Th>
                            <Th> Quien Inspeccionó </Th>
                            <Th> Comentarios de inspección </Th>
                            <Th> PO'S </Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          <Tr>
                            <Td>{formData.numero}</Td>
                            <Td>{formData.cliente}</Td>
                            <Td className="margintopmobil20px">
                              {Moment(formData.fechaDeReciba).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                formData.horaDeReciba}
                            </Td>
                            <Td className="margintopmobil20px">
                              {formData.cantidadRecibida}
                            </Td>
                            <Td className="margintopmobil20px">
                              {formData.status}
                            </Td>
                            <Td className="margintopmobil20px">
                              {formData.quienInspecciono}
                            </Td>
                            <Td className="margintopmobil20px">
                              {formData.comentarios}
                            </Td>
                            <Td className="margintopmobil40px">
                              {formData.po}
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </div>
                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  margintop20px mb-2 scroll">
                      <div className="floatleft">
                        <h5>Detalle</h5>
                      </div>
                      <Label className="floatrightleft">
                        <input
                          type="checkbox"
                          name="VUAP"
                          onChange={(e) => setMEstatusUbicacion(e.target.checked)}
                          className="ml-2"
                          checked={mEstatusUbicacion}
                        />
                        Mismo estatus y ubicación
                      </Label>
                      <Table className=" mb-2">
                        <Thead class="thead-secondary">
                          <Tr>
                            <Th>#</Th>
                            <Th>
                              {" "}
                              {formData.cliente === "Olson Internacional"
                                ? "Line"
                                : "Packing"}
                            </Th>
                            <Th className="minwidth130px">Número de parte</Th>
                            <Th>Descripción</Th>
                            <Th>Lote</Th>
                            <Th className="minwidth150px">Serial</Th>
                            <Th className="minwidth150px">Serial BTI</Th>
                            <Th>Cantidad</Th>
                            <Th className="minwidth130px">Estatus*</Th>
                            <Th className="minwidth180px">Ubicación*</Th>
                            <Th className="minwidth150px">Locación</Th>
                            <Th>Espacios</Th>
                            <Th>Fecha de ubicación* </Th>
                            <Th className="minwidth100px">
                              Hora de ubicación*{" "}
                            </Th>
                            <Th className="minwidth200px">Quién Inspeccionó</Th>
                            <Th className="minwidth200px">Defecto</Th>
                            <Th className="minwidth300px">Comentarios</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {inputList.map((x, i) => {
                            return (
                              x.activo && (
                                <Tr class={i % 2 !== 0 ? "table-active" : ""}>
                                  <Td className="margintopmobil20px">
                                    {i + 1}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.packing}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.numerodeParte}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.descripcion}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.lote}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.serial}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.serialRecibaBTI}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.cantidadRecibida}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <select
                                      name="status"
                                      className=" custom-select"
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                      disabled={!x.editar}>
                                      <option
                                        value="En reciba"
                                        selected={
                                          x.status === "En reciba"
                                            ? true
                                            : false
                                        }>
                                        {"En reciba"}
                                      </option>
                                      <option
                                        value="Aceptado"
                                        selected={
                                          x.status === "Aceptado" ? true : false
                                        }>
                                        Aceptado
                                      </option>
                                      <option
                                        value="Rechazado"
                                        selected={
                                          x.status === "Rechazado"
                                            ? true
                                            : false
                                        }>
                                        Rechazado
                                      </option>
                                    </select>{" "}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <select
                                      name="ubicacion"
                                      className=" custom-select"
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                      disabled={!x.editar}>
                                      {x.status === "Aceptado" && (
                                        <>
                                          <option
                                            value="Almacén"
                                            selected={
                                              x.ubicacion === "Almacén"
                                                ? true
                                                : false
                                            }>
                                            Almacén
                                          </option>
                                          <option
                                            value="Producción"
                                            selected={
                                              x.ubicacion === "Producción"
                                                ? true
                                                : false
                                            }>
                                            Producción
                                          </option>
                                          <option
                                            value="Proveedor externo"
                                            selected={
                                              x.ubicacion ===
                                                "Proveedor externo"
                                                ? true
                                                : false
                                            }>
                                            Proveedor externo
                                          </option>
                                        </>
                                      )}
                                      {x.status === "En reciba" && (
                                        <>
                                          <option
                                            value="Reciba"
                                            selected={
                                              x.ubicacion === "Reciba"
                                                ? true
                                                : false
                                            }>
                                            Reciba
                                          </option>
                                        </>
                                      )}
                                      {x.status === "Rechazado" && (
                                        <>
                                          <option
                                            value="Cuarentena"
                                            selected={
                                              x.ubicacion === "Cuarentena"
                                                ? true
                                                : false
                                            }>
                                            Cuarentena
                                          </option>
                                        </>
                                      )}
                                    </select>
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.ubicacion === "Almacén" && (
                                      <>
                                        <select
                                          name="locacion"
                                          className=" custom-select"
                                          disabled={!x.editar}
                                          onChange={(e) =>
                                            setInputList(
                                              handleInputChangeLocacion(e, i, [
                                                ...inputList,
                                              ])
                                            )
                                          }>
                                          {x.locacion !== "" && (
                                            <option
                                              className=""
                                              value={x.locacion}
                                              selected="true">
                                              {x.locacion}{" "}
                                            </option>
                                          )}
                                          <option
                                            className=""
                                            value=""
                                            selected={
                                              x.locacion === "" ? true : false
                                            }>
                                            Elige locación
                                          </option>
                                          {locaciones.map((locacion, i) => (
                                            <>
                                              <option
                                                className=""
                                                value={locacion.locacion}>
                                                {/*selected={x.locacion === locacion.locacion ? true : false}  */}
                                                {locacion.locacion}
                                              </option>
                                            </>
                                          ))}
                                        </select>
                                      </>
                                    )}
                                    {(x.ubicacion === "Cuarentena" ||
                                      x.ubicacion === "Proveedor externo") && (
                                        <>
                                          <Input
                                            name="locacion"
                                            value={x.locacion}
                                            type="text"
                                            disabled={!x.editar}
                                            onChange={(e) =>
                                              setInputList(
                                                handleInputChangeLocacion(e, i, [
                                                  ...inputList,
                                                ])
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    {x.ubicacion === "Producción" && (
                                      <>
                                        <select
                                          name="locacion"
                                          className=" custom-select"
                                          disabled={!x.editar}
                                          onChange={(e) =>
                                            setInputList(
                                              handleInputChangeLocacion(e, i, [
                                                ...inputList,
                                              ])
                                            )
                                          }>
                                          <option value="Carga">Carga</option>
                                          <option value="Pintado">
                                            Pintado
                                          </option>
                                          <option value="Inspección">
                                            Inspección
                                          </option>
                                        </select>
                                      </>
                                    )}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {x.ubicacion === "Almacén" &&
                                      x.espacioOcupado > 0 && (
                                        <>
                                          <select
                                            name="espacioOcupado"
                                            className=" custom-select"
                                            disabled={!x.editar}
                                            onChange={(e) =>
                                              setInputList(
                                                handleInputChangeEspacio(e, i, [
                                                  ...inputList,
                                                ])
                                              )
                                            }>
                                            <option
                                              value={1}
                                              selected={
                                                x.espacioOcupado === 1
                                                  ? true
                                                  : false
                                              }>
                                              1
                                            </option>
                                            {x.espacioOcupado > 1 && (
                                              <option
                                                value={2}
                                                selected={
                                                  x.espacioOcupado === 2
                                                    ? true
                                                    : false
                                                }>
                                                2
                                              </option>
                                            )}
                                            {x.espacioOcupado > 2 && (
                                              <option
                                                value={3}
                                                selected={
                                                  x.espacioOcupado === 3
                                                    ? true
                                                    : false
                                                }>
                                                3
                                              </option>
                                            )}
                                          </select>
                                        </>
                                      )}
                                  </Td>
                                  <Td
                                    className={
                                      Moment(new Date()).format("YYYY-MM-DD") <
                                        Moment(x.fechaDeUbicacion).format(
                                          "YYYY-MM-DD"
                                        ) || x.fechaDeUbicacion === ""
                                        ? "novalido margintopmobil20px"
                                        : "margintopmobil20px"
                                    }>
                                    <Input
                                      name="fechaDeUbicacion"
                                      type="date"
                                      value={x.fechaDeUbicacion}
                                      disabled={!x.editar}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesFechaUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    <TimeField
                                      name="horaDeUbicacion"
                                      className="w-100 custom-time"
                                      disabled={!x.editar}
                                      value={x.horaDeUbicacion}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {" "}
                                    <Input
                                      name="quienInspecciono"
                                      type="text"
                                      disabled={!x.editar}
                                      value={x.quienInspecciono}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {" "}
                                    <Input
                                      name="defectoCuarentena"
                                      type="textarea"
                                      disabled={!x.editar}
                                      rows="1"
                                      value={x.defectoCuarentena}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />{" "}
                                  </Td>
                                  <Td className="margintopmobil20px">
                                    {" "}
                                    <Input
                                      name="comentariosdeinspeccion"
                                      type="textarea"
                                      disabled={!x.editar}
                                      rows="1"
                                      value={x.comentariosdeinspeccion}
                                      onChange={(e) =>
                                        setInputUbicaciones(
                                          onChangesUbicacion(e, i, [
                                            ...inputList,
                                          ])
                                        )
                                      }
                                    />{" "}
                                  </Td>
                                </Tr>
                              )
                            );
                          })}
                        </Tbody>
                      </Table>
                      {/*<div style={{ marginTop: 20 }}>{JSON.stringify(recibaSerialesSinFiltro)}</div>*/}
                      {/*<div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div>*/}
                    </div>
                  </Row>
                </div>
                <div>
                  <Button
                    className="floatright"
                    onClick={cancelarRecibaIncoming}
                    color="danger">
                    Cancelar
                  </Button>
                  <Button
                    className="floatright"
                    onClick={guardarIncomming}
                    disabled={isDisabled}
                    color="primary">
                    Guardar
                  </Button>
                </div>
              </Fragment>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default Reciba;
